import isNil from 'lodash-es/isNil';
import { MediaPlayerError } from '@yi/core';

import { nr } from '~/common';

import type { ExtendedBrightcovePlayer } from '../../types';

import { POSTER_CLASS_NAME } from '../../brightcove-constants';

const BACKDROP_CLASS_NAME = 'vjs-poster-backdrop';
export function addPosterBackdrop(player: ExtendedBrightcovePlayer): void {
  const posterElement = player.$(`.${POSTER_CLASS_NAME}`);
  if (isNil(posterElement)) {
    nr.noticeError(new MediaPlayerError('brightove player poster element is unavailable'));
    return;
  }

  const backDropElement = document.createElement('div');
  backDropElement.className = BACKDROP_CLASS_NAME;
  backDropElement.style.background =
    'linear-gradient(to bottom,transparent,rgba(0,0,0,.4) 77%,rgba(0,0,0,.4) 100%) 100% 100%/100% 240px no-repeat transparent';
  backDropElement.style.transition =
    'opacity 250ms cubic-bezier(0,.25,.25,1),background-size 250ms cubic-bezier(0,.25,.25,1)';
  backDropElement.style.pointerEvents = 'none';
  backDropElement.style.height = '100%';
  backDropElement.style.zIndex = '10';
  backDropElement.style.position = 'absolute';
  backDropElement.style.top = '0';
  backDropElement.style.bottom = '0';
  backDropElement.style.left = '0';
  backDropElement.style.right = '0';

  posterElement.prepend(backDropElement);
}
